import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ComunicacaoService extends BaseService {

  private endpointNovidades = '/novidade/';
  options: RequestOptions;
  headers: Headers;

  constructor(private http: Http,
    private auth: AuthService, private httpClient: HttpClient) { 
      super();
      this.headers = new Headers({ 'Content-Type': 'application/json' });
      this.options = new RequestOptions({ headers: this.headers });
  }

  obterNovidadesPorModuloId(moduloId: string): Observable<any> {
    return this.http
          .get(this.urlApiComunicacao + this.endpointNovidades + "buscar-novidades-por-modulo-id/" + moduloId, 
              this.auth.obterAuthHeader())
              .pipe(
                map(this.extractData),
                catchError(this.handleError));
  }

  lerNovidade(novidadesId: string) {
    return this.http
          .get(this.urlApiComunicacao + this.endpointNovidades + "novidade-lida?" + novidadesId,
              this.auth.obterAuthHeader())
              .pipe(
                map(this.extractData),
                catchError(this.handleError));
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/comunicacao.service.ts